@if (!pending) {
    @if (displayEntities.data?.length > 0) {
        <div class="table__container">
            <table class="table w-100" mat-table matSort [dataSource]="displayEntities">
                <ng-container matColumnDef="number">
                    <th class="th--55 text-end" mat-header-cell *matHeaderCellDef>#</th>
                    <td class="text-end text-muted font-size-sm" mat-cell *matCellDef="let item; let i = index">
                        {{ i + 1 + this.displayEntities?.paginator?.pageIndex * this.displayEntities?.paginator?.pageSize }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th class="th--name" mat-header-cell *matHeaderCellDef>
                        {{ 'global.forms.labels.name' | translate }}
                    </th>
                    <td class="td--multiline" mat-cell *matCellDef="let item">
                        {{ item.orgName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="icons">
                    <th class="th--60" mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let item">
                        <div class="d-flex align-items-center justify-content-end" (click)="stopPropagation($event)">
                            @if (!readonly) {
                                <ui-icon-bs
                                    [type]="bsIconTypes.Trash3"
                                    [pseudo]="'gray'"
                                    (handlerClick)="handlers.handlerDeleteEntity(item.orgId)" />
                            }
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" uiRowLink (rowActivate)="handlers.handlerRowClick(row)"></tr>
            </table>
        </div>
    } @else {
        <ui-no-matches />
    }
} @else {
    <ui-pre-loader />
}

<paginator [source]="displayEntities"></paginator>
